import { render, staticRenderFns } from "./DashboardCreation.vue?vue&type=template&id=68e6a970&scoped=true"
import script from "./DashboardCreation.vue?vue&type=script&lang=js"
export * from "./DashboardCreation.vue?vue&type=script&lang=js"
import style0 from "./DashboardCreation.vue?vue&type=style&index=0&id=68e6a970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e6a970",
  null
  
)

export default component.exports